// extracted by mini-css-extract-plugin
module.exports = {"suggest":"_3ea6fa5da8--suggest--Lkaqh","suggest-item":"_3ea6fa5da8--suggest-item--BczC7","suggest-error":"_3ea6fa5da8--suggest-error--RHh0N"};